module.exports = __webpack_public_path__ + "static/GorditaMedium-Italic-5251a7dfea856e510df2e501d9e88711.otf";